/* eslint complexity: 0 */
export function supplier_active_drawer(context) {
  const drawer_map = {
    documents: Reflect.get(context.document_drawer_catalog, context.active_document_drawer_key) || null,
    renewals: Reflect.get(context.renewal_drawer_catalog, context.active_renewal_drawer_key) || null,
    incidents: Reflect.get(context.incident_drawer_catalog, context.active_incident_drawer_key) || null,
    revalidation: Reflect.get(context.flagged_drawer_catalog, context.active_flagged_drawer_key) || null,
    register: Reflect.get(context.drawer_catalog, context.active_drawer_key) || null
  };
  return Reflect.get(drawer_map, context.active_tab) || Reflect.get(context.drawer_catalog, context.active_drawer_key) || null;
}

export function build_supplier_drawer_catalog(rows, suppliers, drawer_catalog, drawer_key_resolver, drawer_builder) {
  return rows.reduce((catalog, row) => {
    const supplier_row = suppliers.find((supplier) => supplier.supplier === row.supplier);
    const supplier_drawer = supplier_row ? drawer_catalog[supplier_row.drawer_key] : null;
    if (supplier_row && supplier_drawer) {
      catalog[drawer_key_resolver(row)] = drawer_builder(row, supplier_row, supplier_drawer);
    }
    return catalog;
  }, {});
}

function supplier_form_defaults() {
  return { name: '', category: 'Technology', status: 'Active', risk_score: '30', owner: '', annual_spend: '', supplier_since: '' };
}

function supplier_drawer_payload(form) {
  const payload = {
    ...form,
    annual_spend: form.annual_spend.trim() || 'R 1.2m / yr',
    supplier_since: form.supplier_since || 'Mar 2024',
    owner: form.owner || 'Procurement'
  };
  return payload;
}

function supplier_row_from_form(form, slugify_supplier, risk_tone_from_score, status_meta_from_label) {
  const supplier_name = form.name.trim();
  if (!supplier_name) return null;
  const drawer_key = slugify_supplier(supplier_name);
  const risk_meta = risk_tone_from_score(Number.parseInt(form.risk_score || '30', 10));
  const status_meta = status_meta_from_label(form.status);
  const row = {
    supplier: supplier_name,
    category: form.category,
    status: { label: form.status, class: status_meta.class },
    risk: { label: risk_meta.label, class: risk_meta.class },
    documents: form.status === 'Active' ? 58 : 42,
    payments: status_meta.payments,
    highlighted: true,
    drawer_key
  };
  return row;
}

export function save_supplier_modal_state(context, helpers) {
  const new_row = supplier_row_from_form(context.supplier_form, helpers.slugify_supplier, helpers.risk_tone_from_score, helpers.status_meta_from_label);
  if (!new_row) return null;
  const drawer_key = new_row.drawer_key;
  context.suppliers.unshift(new_row);
  context.tabs = context.tabs.map((tab) => tab.id === 'register' ? { ...tab, count: context.suppliers.length } : tab);
  Reflect.set(context.drawer_catalog, drawer_key, helpers.build_dynamic_drawer(new_row, supplier_drawer_payload(context.supplier_form)));
  context.supplier_form = supplier_form_defaults();
  context.supplier_modal_open = false;
  return drawer_key;
}
